<template>
  <div cass="contained-height-content has-bg-white">
    <sticky class="page-header sticky-page-header page-header--new" :calendarMonth="gApiReady && !googleLogged"
      :classOnRightSlot="'columns is-gapless is-narrow'"
      :back-button="false">
      <div slot="left" class="columns is-vcentered is-gapless">
        <div class="column is-3 minW300p maxW300p has-bg-black is-self-stretched has-text-white columns is-gapless is-vcentered">
          <div class="column is-padding-left">
            <span>{{rdvs.length + reminders.length + options.length + users.length}} actions programmées</span>
          </div>
        </div>
        <router-link :to="{name: 'CalendarList'}" class="column is-narrow is-border-right">
          <a class="page-header-btn is-small has-text-black-ter">
            <span class="icon is-small"><i class="far fa-clock is-size-4"></i></span><span class="is-padding-left-xxsmall has-text-weight-medium">ACTIONS À VENIR</span>
          </a>
        </router-link>
        <div @click="goToPrevDay()" class="control is-margin-left">
          <button class="button is-square is-border button is-small is-transform-none is-grey is-border is-inverted">
              <i class="fal fa-chevron-left"></i>
          </button>
        </div>
        <div @click="goToNextDay()" class="control is-margin-left-xsmall">
          <button class="button is-square is-border button is-small is-transform-none is-grey is-border is-inverted">
              <i class="fal fa-chevron-right"></i>
          </button>
        </div>
        <div class="column is-narrow is-self-stretched is-flex">
          <div class="is-self-centered has-text-centered is-padding-left minW150p">
            <div class="title is-size-5 is-size-4-widescreen"><b class="is-uppercase">{{currentDay|date}}</b></div>
          </div>
        </div>
        <div class="column"></div>
      </div>
      <div class="column is-self-centered is-padding-right-small" slot="left-action">
        <button v-if="todayDate === actualDate" class="button is-small is-transform-none is-static is-border">
          <span class="has-text-grey has-text-weight-medium">Aujourd'hui</span>
        </button>
        <button v-else @click="goToDay(todayFullDate)" class="button is-small is-transform-none is-grey is-border is-inverted">
          <span class="has-text-grey has-text-weight-medium">Aujourd'hui</span>
        </button>
        <button @click="goToMonth" class="button is-small is-transform-none is-grey is-border is-inverted"> 
          <span class="has-text-grey has-text-weight-medium">Mois</span>
        </button>
      </div>
      <a v-if="gApiReady && !googleLogged" @click="googleLogin()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fab fa-google"></i></span><span>Connexion google agenda</span>
      </a>
      <!-- <a @click="newRdv" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-calendar-plus"></i></span>
        <span>Nouveau rendez-vous</span>
      </a>
      <a @click="newReminder" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-alarm-clock"></i></span>
        <span>Nouveau rappel</span>
      </a> -->
      <a @click="open" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-calendar-plus"></i></span>
        <span>Nouvelle action</span>
      </a>
      <google-sync-button slot="left-action"></google-sync-button>
    </sticky>
    <div class="page-content columns is-gapless collapseColumn collapseColumn--left collapseColumn--left--small collapseColumn--alignStart" id="columns-collapse">
      <div class="column is-3 has-bg-white is-border-right"><!-- Max-width important pour que les jours dans le calendrier restent carrés -->
        <div class="has-flatpickr-responsive has-flatpickr-theme--s1 has-flatpickr-padding-h has-bg-white-ter is-border-bottom is-padding-bottom-small">
          <flat-pickr :config="configDateMini"
            id="flatpickr" class="input is-hidden is-radiusless is-shadowless flatpickr-input is-noDecalPosTop"
            name="date"
            v-model="currentDayDate"
            @on-change="goToDay"
          ></flat-pickr>
        </div>
        <div>
          <div v-if="hasFilter" class="is-padding-left-small is-padding-top-xsmall is-padding-bottom-xsmall is-border-top has-bg-annonce">
            <a class="has-text-white is-size-6" @click.prevent.stop="resetFilters">
              <span class="icon"><i class="fas fa-undo"></i></span>
              <span class="is-italic">Réinitialiser tous les filtres</span>
            </a>
          </div>
          <div v-if="panel === 'RDVS'" class="column is-gapless is-12 columns is-multiline is-vcentered is-paddingless-bottom is-padding-top-small is-padding-left-small is-padding-right-small">
            <label for="" class="label is-transform-none has-text-grey is-padding-bottom-xsmall">Type de rendez-vous</label>
            <div class="column is-12 columns is-variable is-1 is-multiline">
              <div v-for="type in rdvTypeList" :key='type.value' class="column is-3 is-paddingless-top is-paddingless-bottom is-paddingless-left">
                <input :id="type.value" v-model="filters.rdv_type" :value="type.label" name="typeRdv"
                        :class="{'is-active' : filters.rdv_type.map(x=> x.value).includes(type.value)}"
                       checked="checked" class="checkradiocase is-primary is-fullwidth" type="checkbox"
                       @change="updateRdvType(filters.rdv_type, `#${type.value}`)">
                <label :for="type.value">{{type.label}}</label>
              </div>
            </div>
          </div>
          <div class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openSellerSelectionQuickView('author')" class="input">
                <div v-if="filters.author && filters.author.length">
                  <span class="">Organisateurs ({{filters.author.length}})</span>
                </div>
                <span v-else class="has-text-grey">Sélectionner organisateur</span>
              </div>
            </div>
          </div>
          <div v-if="panel === 'RDVS'" class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openContactSelectionQuickView()" class="input">
                <div v-if="filters.contact && filters.contact.length">
                  <span class="">contacts ({{filters.contact.length}})</span>
                </div>
                <span v-else class="has-text-grey">Rechercher contact</span>
              </div>
            </div>
          </div>
          <div class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openSellerSelectionQuickView('participant')" class="input">
                <div v-if="filters.seller && filters.seller.length">
                  <span class="" v-if="panel !== 'RDVS'">Participants ({{filters.seller.length}})</span>
                  <span class="" v-else>Utilisateur ({{filters.seller.length}})</span>
                </div>
                <span v-else class="has-text-grey">
                  <span v-if="panel !== 'RDVS'">Rechercher participant</span>
                  <span v-else>Rechercher utilisateur</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-paddingless contained-min-height-inter">
        <div class="tabs is-small is-marginless-bottom has-bg-white is-border-bottom">
          <ul class="has-text-weight-medium is-borderless">
            <li :class="{'is-active':panel === 'RDVS'}"><a @click="panel = 'RDVS'" :class="{'router-link-exact-active is-active has-bg-white-ter':panel === 'RDVS'}"><b class="is-uppercase">Rendez-vous ({{rdvs.length}})</b></a></li>
            <li :class="{'is-active':panel === 'REMINDERS'}" class="is-border-left"><a @click="panel = 'REMINDERS'" :class="{'router-link-exact-active is-active has-bg-white-ter':panel === 'REMINDERS'}"><b class="is-uppercase">Rappel ({{reminders.length}})</b></a></li>
            <li :class="{'is-active':panel === 'OPTIONS'}" class="is-border-left"><a @click="panel = 'OPTIONS'" :class="{'router-link-exact-active is-active has-bg-white-ter':panel === 'OPTIONS'}"><b class="is-uppercase">Fin d'option ({{options.length}})</b></a></li>
            <li v-if="isAdmin || isSectorManager" :class="{'is-active':panel === 'USERS'}" class="is-border-left is-border-right"><a @click="panel = 'USERS'" :class="{'router-link-exact-active is-active has-bg-white-ter':panel === 'USERS'}"><b class="is-uppercase">Expiration document ({{users.length}})</b></a></li>
          </ul>
        </div>

        <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small is-marginless field is-grouped is-borderless">
          <label class="checkbox checkRadioIsHide is-padding-right-xsmall"
                v-for="s in qualifications"
                :for="'filter-'+s.value"
                :key="s.value"
                v-show="panel == 'RDVS'">
            <input type="checkbox" :id="'filter-'+s.value" v-model="qualif" @click="qualificationSelected = s.value" :value="s.value">
            <span class="tag is-radiusless" :class="s.color">
              <span>{{s.label}}</span>
              <span class="icon"><i class="far" :class="s.value ? qualificationSelected === s.value ? 'fa-check-circle' : 'fa-circle' : 'fa-times-circle'"></i></span>
            </span>
          </label>
        </div>

        <div class="is-padding is-border-bottom" v-if="hasFilter">
          <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
          <div class="tags">
            <span class="tag is-primary is-rounded" v-if="filters.author && filters.author.length" v-for="(auth, i) in author">
              {{auth.last_name}} {{auth.first_name}} <a @click="deleteAuth(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.contact && filters.contact.length" v-for="(cont, i) in contact">
              {{cont.last_name}} {{cont.first_name}} <a @click="deleteContact(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.seller && filters.seller.length" v-for="(sel, i) in seller">
              {{sel.last_name}} {{sel.first_name}}<a @click="deleteSeller(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-primary is-rounded" v-if="filters.rdv_type && filters.rdv_type.length" v-for="(type, i) in filters.rdv_type" :key="'type-' + i">
              {{type}} <a @click="deleteTypeFilter(i)" class="icon is-white is-margin-left-xsmall"><i class="fas fa-times-circle has-text-white"></i></a>
            </span>
            <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFilters">
              Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i class="fas fa-undo"></i></span>
            </span>
          </div>
        </div>

        <div class="bulma-calendar">
          <div class="calendar is-large day-view is-padding-left is-padding-right is-padding-bottom has-bg-none is-borderless">
            <div class="calendar-container is-flex" style="min-height: 75vh">
              <div class="is-flex is-column is-space-between w100" v-if="panel == 'RDVS'">
                <template>
                  <div v-for="hour in hoursTab" :key="hour" class="calendar-crmImmoCalendarHourSep" :data-time="hour">
                    <div class="day-events " v-if="rdvsByHour">
                      <calendar-rdv-item v-for="rdv in rdvsByHour[hour]"
                                      :key="rdv.pk"
                                      :rdvs='rdvs'
                                      @openEvent="setCurrentEvent"
                                      :is-open="currentEvent && currentEvent.pk === rdv.pk" :event="rdv" type="RDV"
                                      :selected-event="selectedEvent"
                                      @selectedEvent="val => selectedEvent = val"
                                      class="is-border is-margin-bottom-xsmall"
                      ></calendar-rdv-item>
                    </div>
                  </div>
                </template>
              </div>
              <!-- <div class="day-events is-border" v-show="panel == 'EVENTS_GG'">
              </div> -->
              <div class="is-flex is-column is-space-between w100" v-if="panel == 'REMINDERS'">
                <template>
                  <div v-for="hour in hoursTab" :key="hour" class="calendar-crmImmoCalendarHourSep" :data-time="hour">
                    <div class="day-events" v-if="remindersByHour">
                      <calendar-reminder-item v-for="reminder in remindersByHour[hour]"
                                      :key="reminder.pk"
                                      @openEvent="setCurrentEvent"
                                      :is-open="currentEvent && currentEvent.pk === reminder.pk" :event="reminder" type="REMINDER"
                                      class="is-border is-margin-bottom-xsmall"
                      ></calendar-reminder-item>
                    </div>
                  </div>
                </template>
              </div>
              <div class="is-flex is-column is-space-between w100" v-if="panel == 'OPTIONS'">
                <template>
                  <div v-for="hour in hoursTab" :key="hour" class="calendar-crmImmoCalendarHourSep" :data-time="hour">
                    <div class="day-events" v-if="optionsByHour">
                      <calendar-option-item v-for="option in optionsByHour[hour]"
                                        :key="option.pk"
                                        @openEvent="setCurrentEvent"
                                        :is-open="currentEvent && currentEvent.pk === option.pk" :event="option" type="OPTION"
                                        :selected-event="selectedEvent"
                                        @selectedEvent="val => selectedEvent = val"
                      ></calendar-option-item>
                    </div>
                  </div>
                </template>
                <!-- <div class="day-events">
                  <calendar-option-item v-for="option in options"
                                      :key="option.pk"
                                      @openEvent="setCurrentEvent"
                                      :is-open="currentEvent && currentEvent.pk === option.pk" :event="option" type="OPTION"
                                      :selected-event="selectedEvent"
                                      @selectedEvent="val => selectedEvent = val"
                  ></calendar-option-item>
                </div> -->
              </div>
              <div class="is-flex is-column is-space-between w100" v-if="panel == 'ACCESSES'">
                <div v-if="accesses.length == 0" class="is-padding"><i>Aucune mandat ce jour.</i></div>
                <div v-else class="day-event" v-for="access in accesses" :key="access.pk">
                  <div class="columns">
                    <div class="column is-narrow is-padding-right-large has-text-right is-border-right">
                      <p class="is-margin-top-xsmall has-text-centered">
                        <time :datetime="access.end_date | dtFormat('DD-MMMM-YYYY')">
                          <b>{{access.end_date | prettyTime}}</b>
                        </time>
                      </p>
                      <span class="dot is-medium has-bg-warning"></span>
                    </div>
                    <div class="column">
                      <router-link :to="{name: 'AccessList', query: {end_date: currentDay.format('DD/MM/YYYY')}}">Voir les
                        {{accesses.length}} Mandat(s)
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="is-flex is-column is-space-between w100" v-if="panel == 'USERS'">
                <template>
                  <div class="day-events">
                    <div class="day-event" v-for="user in users" :key="user.pk">
                      <div class="columns has-bg-white">
                        <div class="column is-narrow is-padding-right-large has-text-right is-border-right">
                          <p class="is-margin-top-xsmall has-text-centered">
                            <time :datetime="user | userDate(currentDay) | dtFormat('DD-MMMM-YYYY')" style="visibility: hidden">
                              <b>{{user | userDate(currentDay) | prettyTime}}</b>
                            </time>
                          </p>
                          <span class="dot is-medium has-bg-danger"></span>
                        </div>
                        <div class="column is-flex">
                          <div class="is-self-centered">
                            <router-link :to="{name: 'UserVue', params: {id: user.pk}}">
                              <strong>{{user.first_name}} {{user.last_name}} </strong>
                            </router-link>
                            <div v-if="validityDate(user.rc_professionnelle_validity_date)">
                              Le document RC Professionnelle est en fin de validité
                            </div>
                            <div v-if="validityDate(user.carte_de_transaction_validity_date)">
                              La Carte transaction est en fin de validité
                            </div>
                            <div v-if="validityDate(user.garantie_financiere_validity_date)">
                              La Garantie Financière est en fin de validité
                            </div>
                          </div>
                        </div>
                        <div class="column is-narrow is-self-centered actions">
                          <div class="is-self-centered">
                            <router-link v-if="validityDate(user.rc_professionnelle_validity_date) || validityDate(user.carte_de_transaction_validity_date) || validityDate(user.garantie_financiere_validity_date)" :to="{name: 'UserEdit', params: {id: user.pk, panel: 'DOCS'}}">
                              <a class="has-text-grey is-padding-left is-underline">
                                Voir le document
                              </a>
                            </router-link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import { cleanQuery } from '../../utils'
  import { orderBy, isNil, debounce, isEmpty, cloneDeep } from 'lodash'
  import { mapState, mapGetters } from 'vuex'
  import CalendarEventItem from './CalendarEventItem'
  import CalendarOptionItem from './CalendarOptionItem'
  import CalendarRdvItem from './CalendarRdvItem'
  import CalendarRdvItemOld from './CalendarRdvItemOld'
  import CalendarReminderItem from './CalendarReminderItem'
  import GoogleSyncButton from './GoogleSyncButton'
  import { GoogleMx } from '@/mixins'
  import { bus, EVENTS } from '@/services/bus/index.js'

  export default {
    name: 'CalendarDayView',
    components: {
      CalendarEventItem,
      CalendarOptionItem,
      CalendarRdvItem,
      CalendarRdvItemOld,
      CalendarReminderItem,
      GoogleSyncButton
    },
    mixins: [GoogleMx],
    props: {},
    data () {
      return {
        formatedCurrentMonth: null,
        openFilter: false,
        rdvTypeList: {
          R0: {value: 'R0', label: 'R0'},
          R1: {value: 'R1', label: 'R1'},
          R2: {value: 'R2', label: 'R2'},
          R3: {value: 'R3', label: 'R3'}
        },
        authors: [],
        poles: [],
        author: [],
        seller: [],
        contact: [],
        contact_name: null,
        myRdv: false,
        currentEvent: null,
        currentDay: null,
        currentDayDate: null,
        selectedEvent: null,
        configDate: {
          altFormat: 'F Y',
          altInput: true,
          dateFormat: 'l d F Y',
          disableMobile: true
        },
        configDateMini: {
          inline: true,
          enableTime: false,
          noCalendar: false,
          defaultDate: '2019-04-19 08:30',
          altFormat: 'F j, Y H:i',
          dateFormat: 'Y-m-d H:i',
          time_24hr: true
        },
        panel: 'RDVS',
        filters: {
          author: [],
          rdv_type: [],
          seller: [],
          successful: null,
          canceled: null,
          deferred: null,
          contact: []
        },
        initFilters: {
          author: [],
          rdv_type: [],
          seller: [],
          successful: null,
          canceled: null,
          deferred: null,
          contact: []
        },
        qualif: null,
        qualificationSelected: null,
        qualifications: [
          {value: 'successful', label: 'Effectué', color: 'is-success'},
          {value: 'deferred', label: 'Reporté', color: 'is-warning'},
          {value: 'canceled', label: 'Annulé', color: 'is-danger'},
          {value: null, label: 'Tous', color: 'is-draft'}
        ]
      }
    },
    filters: {
      date: function (value) {
        let date = moment(value).format('dddd DD MMMM')
        return date
      },
      userDate (user, currentDay) {
        let result = []
        if (user.carte_de_transaction_validity_date) {
          result.push(user.carte_de_transaction_validity_date)
        }
        if (user.garantie_financiere_validity_date) {
          result.push(user.garantie_financiere_validity_date)
        }
        if (user.rc_professionnelle_validity_date) {
          result.push(user.rc_professionnelle_validity_date)
        }
        return result.find(x => {
          return moment(x).format('YYYYMMDD') === moment(currentDay).format('YYYYMMDD')
        })
      }
    },
    computed: {
      ...mapState({
        calendarEvents: 'calendarEvents',
        googleLogged: 'googleLogged',
        quickview: 'quickview',
        runningOptions: 'runningOptions',
        polesList: 'poles'
      }),
      ...mapGetters(['isAdmin', 'isSectorManager', 'isManager', 'isSeller', 'currentUserPk']),
      accesses () {
        if (this.events && 'accesses' in this.events) {
          return Object.values(this.events.accesses)
        }
        return []
      },
      hasFilter () {
        if (cleanQuery(this.filters) === cleanQuery(this.initFilters)) return false
        for (const key in this.filters) {
          if ((Array.isArray(this.filters[key]) || typeof this.filters[key] === 'object') && !isEmpty(this.filters[key])) {
            return true
          } else if (typeof this.filters[key] !== 'object' && this.filters[key] !== undefined && this.filters[key] !== null && this.filters[key] !== 0 &&
            this.filters[key] !== '') {
            return true
          }
        }
        return false
      },
      hoursTab () {
        let i = 0
        let hours = []
        for (i; i < 24; i++) {
          let hour = moment().hour(i)
          hour = moment(hour).format('HH')
          hours.push(hour + ':00')
        }
        return hours
      },
      rdvs () {
        if (this.events && 'rdvs' in this.events) {
          let rdvs = Object.values(this.events.rdvs)
          if (this.myRdv) {
            rdvs = rdvs.filter(x => x.seller === this.currentUserPk || x.guests.includes(this.currentUserPk))
          }
          if (this.qualificationSelected) {
            rdvs = rdvs.filter(x => x[this.qualificationSelected])
          }
          if ('author' in this.filters && this.filters.author && this.filters.author.length && this.panel === 'RDVS') {
            let allAuthor = []
            let selectedAuthor = []
            this.filters.author.forEach(author => {
              selectedAuthor[author] = []
              selectedAuthor[author] = rdvs.filter(x => x.author === author.pk)
              allAuthor = allAuthor.concat(selectedAuthor[author])
            })
            rdvs = allAuthor
          }
          if ('contact' in this.filters && this.filters.contact && this.filters.contact.length && this.panel === 'RDVS') {
            let allContact = []
            let selectedContact = []
            this.filters.contact.forEach(contact => {
              selectedContact[contact] = []
              selectedContact[contact] = rdvs.filter(x => x.contact === contact.pk)
              allContact = allContact.concat(selectedContact[contact])
            })
            rdvs = allContact
          }
          if ('seller' in this.filters && this.filters.seller && this.filters.seller.length && this.panel === 'RDVS') {
            let allSeller = []
            let selectedSeller = []
            this.filters.seller.forEach(seller => {
              selectedSeller[seller] = []
              selectedSeller[seller] = rdvs.filter(x => x.seller === seller.pk)
              allSeller = allSeller.concat(selectedSeller[seller])
            })
            rdvs = allSeller
          }
          if (this.filters.rdv_type && this.filters.rdv_type.length) {
            let rdvsType = []
            let allRdvType = []
            for (let type of this.filters.rdv_type) {
              rdvsType[type] = []
              rdvsType[type] = rdvs.filter(x => { return x.rdv_type === type })
              allRdvType = allRdvType.concat(rdvsType[type])
            }
            rdvs = allRdvType
          }
          return orderBy(rdvs, x => {
            return x.contact_name
          }, 'asc')
        }
        return []
      },
      rdvsByHour () {
        let rdvHours = {}
        for (let hour of this.hoursTab) {
          rdvHours[hour] = []
        }
        for (let rdv of this.rdvs) {
          let hour = moment(rdv.date).format('HH')
          hour = hour + ':00'
          rdvHours[hour].push(rdv)
        }
        return rdvHours
      },
      remindersByHour () {
        let remindersHours = {}
        for (let hour of this.hoursTab) {
          remindersHours[hour] = []
        }
        for (let reminder of this.reminders) {
          let hour = moment(reminder.date).format('HH')
          hour = hour + ':00'
          remindersHours[hour].push(reminder)
        }
        return remindersHours
      },
      optionsByHour () {
        let optionsByHour = {}
        for (let hour of this.hoursTab) {
          optionsByHour[hour] = []
        }
        for (let option of this.options) {
          let hour = moment(option.end_date).format('HH')
          hour = hour + ':00'
          optionsByHour[hour].push(option)
        }
        return optionsByHour
      },
      usersByHour () {
        let usersHours = {}
        for (let hour of this.hoursTab) {
          usersHours[hour] = []
        }
        for (let user of this.users) {
          if (user.carte_de_transaction_validity_date) {
            let hour = moment(user.carte_de_transaction_validity_date).format('HH')
            hour = hour + ':00'
            usersHours[hour].push(user)
          }
          if (user.garantie_financiere_validity_date) {
            let hour = moment(user.garantie_financiere_validity_date).format('HH')
            hour = hour + ':00'
            usersHours[hour].push(user)
          }
          if (user.rc_professionnelle_validity_date) {
            let hour = moment(user.rc_professionnelle_validity_date).format('HH')
            hour = hour + ':00'
            usersHours[hour].push(user)
          }
        }
        return usersHours
      },
      orderedRdvs () {
        return orderBy(this.rdvs, x => {
          return moment(x.date)
        }, 'desc')
      },
      rdvsLength () {
        if (this.events && 'rdvs' in this.events) return Object.values(this.events.rdvs).length
        else return 0
      },
      users () {
        if (this.events && 'users' in this.events) {
          return Object.values(this.events.users)
        }
        return []
      },
      options () {
        if (this.events && 'options' in this.events) {
          let options = Object.values(this.events.options)
          return orderBy(options, x => {
            return moment(x.end_date)
          }, 'asc')
        }
        return []
      },
      reminders () {
        if (this.events && 'reminders' in this.events) {
          let reminders = Object.values(this.events.reminders)
          if ('author' in this.filters && this.filters.author && this.filters.author.length && this.panel === 'REMINDERS') {
            let allAuthor = []
            let selectedAuthor = []
            this.filters.author.forEach(author => {
              selectedAuthor[author] = []
              selectedAuthor[author] = reminders.filter(x => x.author === author.pk)
              allAuthor = allAuthor.concat(selectedAuthor[author])
            })
            reminders = allAuthor
          }
          if ('seller' in this.filters && this.filters.seller && this.filters.seller.length && this.panel === 'REMINDERS') {
            let allSeller = []
            let selectedSeller = []
            this.filters.seller.forEach(seller => {
              selectedSeller[seller] = []
              selectedSeller[seller] = reminders.filter(x => x.user === seller.pk)
              allSeller = allSeller.concat(selectedSeller[seller])
            })
            reminders = allSeller
          }
          return orderBy(reminders, x => {
            return moment(x.date)
          }, 'asc')
        }
        return []
      },
      events () {
        let key = this.currentDay.format('DD/MM/YYYY')
        if (key in this.calendarEvents) {
          return this.calendarEvents[key]
        }
        return []
      },
      today () {
        return moment()
      },
      todayDate () {
        return moment().format('DD/MM/YYYY')
      },
      todayFullDate () {
        return new Date(moment())
      },
      actualDate () {
        return moment(this.currentDay).format('DD/MM/YYYY')
      },
      endDate () {
        return this.currentDay.clone().endOf('day').subtract(1, 'hours').format('DD/MM/YYYY')
      },
      startDate () {
        return this.currentDay.clone().startOf('day').subtract(1, 'hours').format('DD/MM/YYYY')
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            if (params.type === 'author') {
              results.entities.forEach(x => {
                this.author.push(x)
                this.filters.author.push(x)
              })
              this.$nextTick(() => {
                this.updateCurrentDay()
              })
            } else if (params.type === 'participant') {
              results.entities.forEach(x => {
                this.seller.push(x)
                this.filters.seller.push(x)
              })
              this.$nextTick(() => {
                this.updateCurrentDay()
              })
            }
          } else if (mode === 'CONTACT_SELECTION') {
            results.entities.forEach(x => {
              this.contact.push(x)
              this.filters.contact.push(x)
            })
            this.$nextTick(() => {
              this.updateCurrentDay()
            })
          } else if (mode === 'NEW_CALENDAR_ACTION') {
            console.log(results.val)
            let day
            let month
            let year
            if ('reminder' in results.val && results.val.reminder) {
              let date = moment(results.val.reminder.date)
              day = date.get('date')
              month = date.get('month')
              month = month + 1
              year = date.get('year')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year, panel: 'REMINDERS' } })
              this.panel = 'REMINDERS'
            } else if ('rdv' in results.val && results.val.rdv) {
              let date = moment(results.val.rdv.date)
              day = date.get('date')
              month = date.get('month')
              month = month + 1
              year = date.get('year')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year } })
              this.panel = 'RDVS'
            }
          }
        }
      },
      '$route' (val) {
        this.updateCurrentDay()
      },
      currentDay (val, old) {
        if (isNil(old) || val.isSame(old) === false) {
          this.loadEvents()
        }
      }
    },
    methods: {
      open () {
        this.$store.commit('setQuickview', {mode: 'NEW_CALENDAR_ACTION'})
      },
      deleteAuth (i) {
        if (Array.isArray(this.filters.author)) {
          this.filters.author.splice(i, 1)
          this.author.splice(i, 1)
        } else {
          this.$set(this.filters, 'author', [])
          this.$set(this, 'author', [])
        }
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      },
      deleteSeller (i) {
        if (Array.isArray(this.filters.seller)) {
          this.filters.seller.splice(i, 1)
          this.seller.splice(i, 1)
        } else {
          this.$set(this.filters, 'seller', [])
          this.$set(this, 'seller', [])
        }
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      },
      deleteContact (i) {
        if (Array.isArray(this.filters.contact)) {
          this.filters.contact.splice(i, 1)
          this.contact.splice(i, 1)
        } else {
          this.$set(this.filters, 'contact', [])
          this.$set(this, 'contact', [])
        }
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      },
      openContactSelectionQuickView () {
        let params = {
          mode: 'append'
        }
        this.$store.commit('setQuickview', {mode: 'CONTACT_SELECTION', params: params})
      },
      openSellerSelectionQuickView (value) {
        let params = {}
        params.facets = {
          'USER': ['is_external:False']
        }
        params.mode = 'append'
        params.type = value
        this.$store.commit('setQuickview', {mode: 'SELLER_SELECTION', params: params})
      },
      updateKeyFilter (e, key) {
        this.$set(this.filters, key, e)
        this[key] = null
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      },
      goToMonth () {
        this.$router.push({name: 'CalendarMonthView'})
      },
      googleLogin () {
        window.gapi.auth2.getAuthInstance().signIn().then(res => {
        })
      },
      resetFilters () {
        this.contact = []
        this.author = []
        this.seller = []
        this.filters = cloneDeep(this.initFilters)
      },
      inputChange: debounce(function () {
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      }, 300),
      updatePoleFilter (e) {
        if (e && Array.isArray(e)) {
          this.$set(this.filters, 'pole', e)
        } else {
          this.$set(this.filters, 'pole', null)
        }
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      },
      updateAuthorFilter (e) {
        this.$set(this.filters, 'author', e.pk)
        this.$set(this, 'author', e)
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      },
      updateSellerFilter (e) {
        this.$set(this.filters, 'seller', e.pk)
        this.$set(this, 'seller', e)
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      },
      updateContactFilter (e) {
        this.$set(this.filters, 'contact', e.pk)
        this.$set(this, 'contact', e)
        this.$nextTick(() => {
          this.updateCurrentDay()
        })
      },
      updateRdvType (e, el) {
        this.$set(this.filters, 'rdv_type', e)
        this.$nextTick(() => {
          this.fixFocus(el)
          this.updateCurrentDay()
        })
      },
      fixFocus (element) {
        // Debug focus persistant sur les cases à cocher (app/Maison) avec chrome
        document.querySelector(element).blur()
      },
      getAuthors (query) {
        let profilsPk = []
        if (this.profilOrderList && this.profilOrderList.length) {
          profilsPk = this.profilOrderList.filter(x => !x.is_external).map(x => x.pk)
        }
        let params = {
          profil: profilsPk
        }
        if (query) params.query = query
        this.$api.userService.get(params).then(r => {
          this.authors = r.data.items
        })
      },
      updateMyRDV () {
        this.myRdv = !this.myRdv
        this.updateCurrentDay()
      },
      validityDate (user) {
        return moment(user).format('YYYYMMDD') === moment(this.currentDay).format('YYYYMMDD')
      },
      newReminder () {
        let params = {}
        if (this.currentDay) {
          params.date = this.currentDay.format('DD/MM/YYYY')
        }
        this.$store.commit('setQuickview', {mode: 'NEW_REMINDER', params: params})
      },
      newRdv () {
        let params = {}
        if (this.currentDay) {
          params.day = moment(this.currentDay).date()
          params.month = moment(this.currentDay).month()
          params.year = moment(this.currentDay).year()
        }
        this.$router.push({name: 'CalendarCreate', query: params})
      },
      updateCurrentDay () {
        if ('day' in this.$route.query && 'month' in this.$route.query) {
          let day = this.$route.query.day
          let month = this.$route.query.month
          let year = 'year' in this.$route.query ? this.$route.query.year : moment().year()
          this.currentDay = moment(`${day}/${month}/${year}`, 'DD/MM/YYYY')
        } else {
          this.currentDay = moment()
        }
        this.currentDayDate = new Date(this.currentDay)
        this.formatedCurrentMonth = moment(this.currentDay).format('YYYY-MM-DD HH:mm')
      },
      loadEvents () {
        this.loadRdvs()
        this.loadReminders()
        if (this.isAdmin || this.isSectorManager || this.isManager || this.isSeller) {
          this.loadOptions()
        }
        if (this.isAdmin || this.isSectorManager) {
          this.loadUsersTrans()
          this.loadUsersGar()
          this.loadUsersRc()
        }
        let queryString = `day=${this.currentDay.format('DD')}&month=${this.currentDay.format('MM')}&year=${this.currentDay.format('YYYY')}`
        if (this.$route.query.panel) this.$router.replace(`?${queryString}`)
        else this.$router.push(`?${queryString}`)
      },
      loadAccesses () {
        let params = {
          end_date__gte: this.startDate,
          end_date__lte: this.endDate,
          per_page: 100
        }
        this.isLoadingAccesses = true
        this.$api.accessService.get(params)
          .then(res => {
            let accesses = res.data.items
            accesses.forEach(x => {
              let date = moment(x.end_date, 'DD/MM/YYYY')
              let key = date.format('DD/MM/YYYY')
              this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'accesses'})
            })
            this.isLoadingAccesses = false
          })
      },
      loadUsersTrans () {
        let params = {
          carte_de_transaction_validity_date__gte: this.startDate,
          carte_de_transaction_validity_date__lte: this.endDate,
          per_page: 100
        }
        // this.isLoadingUsers = false
        this.$api.userService.get(params)
          .then(res => {
            let users = res.data.items
            users.forEach(x => {
              let date = moment(x.carte_de_transaction_validity_date)
              let key = date.format('DD/MM/YYYY')
              this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'users'})
            })
          })
      },
      loadUsersGar () {
        let params = {
          garantie_financiere_validity_date__gte: this.startDate,
          garantie_financiere_validity_date__lte: this.endDate,
          per_page: 100
        }
        // this.isLoadingUsers = false
        this.$api.userService.get(params)
          .then(res => {
            let users = res.data.items
            users.forEach(x => {
              let date = moment(x.garantie_financiere_validity_date)
              let key = date.format('DD/MM/YYYY')
              this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'users'})
            })
          })
      },
      loadUsersRc () {
        let params = {
          rc_professionnelle_validity_date__gte: this.startDate,
          rc_professionnelle_validity_date__lte: this.endDate,
          per_page: 100
        }
        // this.isLoadingUsers = false
        this.$api.userService.get(params)
          .then(res => {
            let users = res.data.items
            users.forEach(x => {
              let date = moment(x.rc_professionnelle_validity_date)
              let key = date.format('DD/MM/YYYY')
              this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'users'})
            })
          })
      },
      loadOptions () {
        let params = {
          status: ['approved', 'waiting_list'],
          end_date__gte: this.startDate,
          end_date__lte: this.endDate,
          per_page: 100
        }
        this.isLoadingOptions = true
        this.$api.optionService.get(params)
          .then(res => {
            let options = res.data.items
            options.forEach(x => {
              let date = moment(x.end_date)
              let key = date.format('DD/MM/YYYY')
              this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'options'})
            })
            this.isLoadingOptions = false
          })
      },
      loadRdvs () {
        let params = {
          date__gte: this.startDate,
          date__lte: this.endDate,
          per_page: 100
        }
        this.isLoadingRdvs = true
        this.$api.rdvService.get(params)
          .then(res => {
            let rdvs = res.data.items
            rdvs.forEach(x => {
              let date = moment(x.date)
              let key = date.format('DD/MM/YYYY')
              this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'rdvs'})
            })
            this.isLoadingRdvs = false
          })
      },
      loadReminders () {
        let params = {
          date__gte: this.startDate,
          date__lte: this.endDate,
          per_page: 100
        }
        this.isLoadingReminders = true
        this.$api.reminderService.get(params)
          .then(res => {
            let reminders = res.data.items
            reminders.forEach(x => {
              let date = moment(x.date)
              let key = date.format('DD/MM/YYYY')
              this.$store.commit('addCalendarEvent', {event: x, key: key, type: 'reminders'})
            })
            this.isLoadingReminders = false
          })
      },
      goToNextDay () {
        let d = this.currentDay.clone()
        d.add(1, 'days')
        this.currentDay = d.clone()
        this.currentDayDate = new Date(this.currentDay)
      },
      goToPrevDay () {
        let d = this.currentDay.clone()
        d.subtract(1, 'days')
        this.currentDay = d.clone()
        this.currentDayDate = new Date(this.currentDay)
      },
      goToDay (e) {
        let result
        if (Array.isArray(e)) {
          result = e[0]
        } else {
          result = e
        }
        let day = new Date(result).getDate()
        let month = new Date(result).getMonth() + 1
        let year = new Date(result).getFullYear()
        this.currentDay = moment(`${day}/${month}/${year}`, 'DD/MM/YYYY')
      },
      setCurrentEvent (event) {
        this.currentEvent = event
      }
    },
    created () {
      console.log(this.$route)
      bus.$on(EVENTS.UPDATE_OPTION, this.loadEvents)
      this.updateCurrentDay()
      this.getAuthors()
      this.poles = this.polesList.slice()
      if ('panel' in this.$route.query) {
        this.panel = this.$route.query.panel
      }
    },
    destroyed () {
      bus.$off(EVENTS.UPDATE_OPTION)
    }
  }
</script>

<style scoped>
  .select {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/calendar/CalendarDayView.vue